import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { connectUserStore } from "../../../hoc/connectStore/connectUserStore";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

const MenuDesktop = (props) => {
  const { anchorEl, menuId, isMenuOpen, handleMenuClose, isAuthenticated } =
    props;

  const openLoginClick = () => {
    props.authModal(true, false, false);
    handleMenuClose();
  };

  const openRegisterClick = () => {
    props.authModal(false, true, false);
    handleMenuClose();
  };

  return (
    <Wrapper>
      <Menu
        style={{
          top: 40,
        }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {isAuthenticated && props.profile ? (
          <div>
            <Link to={`/person/edit/${props.profile.id}`}>
              <MenuItem onClick={handleMenuClose}>پروفایل کاربری</MenuItem>
            </Link>
            <a
              onClick={(e) => {
                localStorage.clear();
                props.history.push("/login");
              }}
            >
              <MenuItem onClick={handleMenuClose}>خروج</MenuItem>
            </a>
          </div>
        ) : (
          <div>
            <MenuItem onClick={openRegisterClick}>عضویت</MenuItem>
            <MenuItem onClick={openLoginClick}>ورود</MenuItem>
          </div>
        )}
      </Menu>
    </Wrapper>
  );
};

export default connectUserStore(withRouter(MenuDesktop));
